module.exports = __webpack_public_path__ + "img/04.fc689435.jpg";